import React from "react";
import {User} from "@/pbgen/v1/main_pb";

export interface GlobalState {
  currentUser: User,
}

export const emptyUser = (): User => {
  return new User();
}

export const GlobalContext = React.createContext<{
  globalState: GlobalState;
  setGlobalState: (newValue: GlobalState) => void;
}>(
  // 利用されないのだが、各項を optional にすると利用時に面倒なので、実体として指定する
  {
    globalState: {
      currentUser: emptyUser(),
    },
    setGlobalState: (_: GlobalState) => {},
  }
);

const BearerTokenKey = "BearerToken"

export const bearerToken = (): string => {
  return localStorage.getItem(BearerTokenKey) ?? "";
}

export const setBearerToken = (bearerToken: string) => {
  localStorage.setItem(BearerTokenKey, bearerToken);
}

export const removeBearerToken = () => {
  localStorage.removeItem(BearerTokenKey);
}
